"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { useMatchMedia } from "../use-match-media/use-match-media";
var INITIAL_VIEWPORT_STATE = {
    isSmall: false,
    isMedium: false,
    isLarge: false,
    isVertical: false,
    isHorizontal: false,
};
var ViewportContext = createContext(INITIAL_VIEWPORT_STATE);
export function ViewportProvider(_a) {
    var children = _a.children;
    var isSmall = useMatchMedia("(max-width: 1024px)");
    var isMedium = useMatchMedia("(min-width: 1024px)");
    var isLarge = useMatchMedia("(min-width: 1280px)");
    var isVertical = false;
    var isHorizontal = false;
    return (_jsx(ViewportContext.Provider, { value: __assign(__assign({}, INITIAL_VIEWPORT_STATE), { isSmall: isSmall, isMedium: isMedium, isLarge: isLarge, isVertical: isVertical, isHorizontal: isHorizontal }), children: children }));
}
export function useViewport() {
    return useContext(ViewportContext);
}
